import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class LabourAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      UomId: "",
      UomData: [],
      uom: "",
      description: "",
      hsnCode: "",
      errors: {},
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      loading: true,
      color: '',
      labourData: props.location?.state?.data
    };
  }

  componentDidMount() {
    this.fetchUomList()
    const { labourData } = this.state || {};
    if (labourData) {
      this.setState({
        name: labourData.name,
        hsnCode: labourData.hsnCode,
        description: labourData.description,
        UomId: labourData.uom,
      })
      setTimeout(() => {
        this.setState({ loading: false, });
      }, 500);
    } else {
      setTimeout(() => {
        this.setState({ loading: false, });
      }, 500);
    }
  }

  fetchUomList = async () => {
    axios({
      method: 'get',
      url: '/uoms',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        console.log("this is data", res.data)
        this.setState({
          UomData: res.data,
          loading: false
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  // handleChange = (event) => {
  //   const { name, value } = event.target;
  //   let errors = { ...this.state.errors };
  //   if (value.trim()) {
  //     delete errors[name];
  //   }
  //   this.setState({ [name]: value, errors });
  // };

  handleChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };
    let newValue = value;

    if (name === 'hsnCode') {
      newValue = value.replace(/\D/g, '').slice(0, 8);
    }

    if (newValue.trim()) {
      delete errors[name];
    }

    this.setState({ [name]: newValue, errors });
  };


  validateForm = () => {
    const errors = {};
    const name = this.state.name.trim();
    const hsnCode = this.state.hsnCode.trim();
    const description = this.state.description.trim();
    const UomId = this.state.UomId;
    if (!name) {
      errors.name = "Name is required";
    }
    // else if (!/^[A-Za-z0-9\s]+$/.test(name)) {
    //   errors.name = "Name must contain only letters, numbers, and spaces";
    // } 
    else if (name.length < 3) {
      errors.name = "Name must be at least 3 characters";
    } else if (name.length > 30) {
      errors.name = "Name must not exceed 30 characters";
    }
    if (description && description.trim().length > 0) {
      if (description.length < 3) {
        errors.description = "Description must be at least 3 characters";
      }
      else if (description.length > 200) {
        errors.description = "Description must not exceed 200 characters";
      }
    }
    if (hsnCode) {
      if (!/^\d{4}(\d{2})?(\d{2})?$/.test(hsnCode)) {
        errors.hsnCode = "HSN Code must be 4, 6, or 8 digits";
      }
    }
    if (!UomId) {
      errors.UomId = "Please select a UOM";
    }
    return errors;
  };

  onSubmit = async (e) => {
    // debugger;
    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    this.setState({ loading: true });
    const { labourData } = this.state || {};
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const payload = {
        name: this.state.name,
        hsnCode: this.state.hsnCode,
        description: this.state.description,
        uom: this.state.UomId,
      };
      let labourStatusResponse;
      if (labourData && labourData.labourid) {
        labourStatusResponse = await axios.put(`/labours/${labourData.labourid}`, payload, { headers });
      } else {
        labourStatusResponse = await axios.post('/labours', payload, { headers });
      }
      // await axios.post("/labours", payload, { headers });
      this.setState({
        name: "",
        hsnCode: "",
        errors: {},
        showToast: true,
        toastMessage: labourStatusResponse.data.message ? labourStatusResponse.data.message : "Labour  created successfully!",
        toastVariant: "success",
        color: 'green',
      },
        () => {
          setTimeout(() => {
            this.props.history.push('/LabourList');
            this.setState({ loading: false });
          }, 600);
        });
    } catch (error) {
      this.setState({
        showToast: true,
        toastMessage: error.response?.data?.message || "Error adding labour",
        toastVariant: "danger",
        loading: false,
        color: 'red',
      });
    }
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/LabourList");
      this.setState({ loading: false });
    }, 500);
  }
  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}

        />
        <CommonLoader isLoading={this.state.loading}>
          <Container className=" pt-4">
            <Card className="shadow-sm rounded border-0">
              <Card.Header>
                <strong>{this.state.labourData?.labourid ? "Update Labour" : ' Add Labour'}</strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  <Row className="mb-3">
                    <Col xs={12} md={6} lg={3}>

                      <Form.Group controlId="formName">
                        <Form.Label className="required">Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter labour name"
                          name="name"
                          value={this.state.name}
                          onChange={this.handleChange}
                          isInvalid={!!this.state.errors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6} lg={2}>
                      <Form.Group controlId="formHsnCode">
                        <Form.Label >HSN Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter HSN code"
                          name="hsnCode"
                          value={this.state.hsnCode}
                          isInvalid={!!this.state.errors.hsnCode}
                          onChange={this.handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.hsnCode}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                      <Form.Group controlId="uomSelect">
                        <Form.Label className="text-muted required">UOM</Form.Label>
                        <Form.Control as="select"
                          name="UomId"
                          className="form-select"
                          value={this.state.UomId}
                          onChange={this.handleChange}
                          isInvalid={!!this.state.errors.UomId}
                        >
                          <option value="" >Select UOM</option>
                          {this.state.UomData.map(Uom => (
                            <option key={Uom.id} value={Uom.id}>{Uom.name}</option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.UomId}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                      <Form.Group controlId="formDescription">
                        <Form.Label className="">Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={1}
                          placeholder="Enter item Description"
                          name="description"
                          value={this.state.description}
                          onChange={this.handleChange}
                          isInvalid={!!this.state.errors.description}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.description}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className='add-cancel-btn '>
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                      {this.state.labourData?.labourid ? "Update" : "Add"}
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel " onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Container>
        </CommonLoader >
      </>
    );
  }
}
